module.exports = __webpack_public_path__ + "c051ed4a060e710007ee84962a883faa.svg";